<template>
    <kiosk-layout formContainer>
        <template v-slot:title>
            <span class="inline-flex items-center gap-3">
                <font-awesome-icon widthAuto :icon="faArrowsDownToPeople" class="text-base"></font-awesome-icon>
                <span>New Group Import</span>
            </span>
        </template>
        <template v-slot:description> Create and update Voxie groups in bulk. </template>

        <form-wrapper
            :sections="[
                { id: 'template', label: 'Template' },
                { id: 'upload', label: 'Upload' },
            ]"
        >
            <group-import-new-template id="template"></group-import-new-template>
            <div id="upload">
                <group-import-new-upload @selected="selectedFile"></group-import-new-upload>
            </div>

            <vx-sticky-footer>
                <vx-button
                    :href="`/kiosk/teams/${props.teamId}/groups/imports`"
                    data-test="cancel-button"
                    class="w-20"
                    size="lg"
                    color="muted"
                >
                    Cancel
                </vx-button>
                <vx-button
                    @click="submit()"
                    data-test="submit-button"
                    :disabled="!file"
                    class="grow"
                    size="lg"
                    color="primary"
                    :loading="submitting"
                >
                    Import
                </vx-button>
            </vx-sticky-footer>
        </form-wrapper>
    </kiosk-layout>
</template>

<script lang="ts" setup>
import { VxButton, VxStickyFooter } from '@voxie/frontend-components';
import { faArrowsDownToPeople } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import FormWrapper from '~/components/general/FormWrapper.vue';
import GroupImportNewTemplate from '~/components/group-import/new/GroupImportNewTemplate.vue';
import GroupImportNewUpload from '~/components/group-import/new/GroupImportNewUpload.vue';
import KioskLayout from '~/components/kiosk/KioskLayout.vue';
import { useGroupImportSubmit } from '~/components/group-import/new/useGroupImportSubmit';
import { stringifyQueryString } from '~/utils/string';

const props = defineProps<{
    teamId: number;
}>();

const { file, submitting, selectedFile, submit } = useGroupImportSubmit(
    props.teamId,
    (data) => `/kiosk/teams/${props.teamId}/groups/imports?${stringifyQueryString({ ...data, success: 1 })}`
);
</script>
